export const FACEBOOK_LIVE = "facebookLive";
export const DOMESTIKA_LIVE = "liveSession";
